import React from 'react'
import ButtonSmallIcon from '../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon'
import useSingleOrganization from '../../../hooks/useSingleOrganization'
import { WithModalConfirmation } from '../../../../../common/components/organisme/ModalWindow/ModalWindow'
import useNavigationApp from '../../../../../navigation/useNavigationApp'
import { useAuth } from '../../../../auth/hooks'
import { userRoles } from '../../../../user/types/user.types'
import NewOragnizationModal from '../../NewOrganization/NewOragnizationModal/NewOragnizationModal'
import useQueryURL from '../../../../../common/hooks/useQueryURL'

export default function ActionSingleOrganization() {
    const {singleOrganizationQuery:{data, isLoading, isError}, deleteOrganizationQuery} = useSingleOrganization()

    const navigationApp = useNavigationApp()
    const {userRole} = useAuth()
    const{setQueryValue} = useQueryURL()
    const MODAL_ID_MODIFY = "modal_update_org"

    const handleDelete = () => {
        deleteOrganizationQuery.mutate({callback: ({result, error}) => {
            if (!error) {
                navigationApp.goToOrganizationList()
            }
        }})
    }

    if (isLoading || isError){
        return <></>
    }

    if (userRole && userRole < userRoles.ADMIN){
        return <></>
    }

    const handleModify = () => {
        setQueryValue({[MODAL_ID_MODIFY]: "true"})
    }
    
  return (
    <div style={{ display: "flex", gap: 10 }}>
        
      <ButtonSmallIcon
        iconType={"edit-sheet"}
        label="Modifier"
        variant="stack"
        onClick={handleModify}
      />
      { userRole && userRole >= userRoles.SUPER_ADMIN &&
      <WithModalConfirmation 
        modalTitle={"Confirmation"}
        confirmLabel="Supprimer"
        cancelLabel="Annuler"
        modalDescription={"Êtes-vous sûr de vouloir supprimer l'organisation "+data?.organization_name+" ?"}
        onComfirm={handleDelete}
        buttonRender={
            ({openModal}) => (
                <ButtonSmallIcon
                    iconType={"trash"}
                    label="Supprimer"
                    variant="stack"
                    onClick={openModal}
                />
            )
        }
        />
    }
    <NewOragnizationModal isUpdate organizationIdToUpdate={data?.organization_id} modalId={MODAL_ID_MODIFY} />
    </div>
  )
}
